import VueRouter from 'vue-router';
import store from './store'

function authGuard(from, to , next) {
    if (store.state.auth.authenticated) {
        next();
    } else {
        next(false);
    }
}

function defaultRedirect(target) {
    if (store.state.auth.authenticated) {
        return '/customers/'+store.state.auth.user.cardCode
    } else {
        return '/login'
    }
}
export default new VueRouter({
    mode: 'history',
    routes: [{
        path: '*',
        redirect: defaultRedirect
    }, {
        path: '/login',
        name: 'login',
        component: () => import('./views/Auth/page')
    }, {
        path: '/',
        beforeEnter: authGuard,
        redirect: defaultRedirect,
        component: () => import('./views/AppLayout'),
        children: [{
            path: 'products',
            component: () => import('./views/products/page.vue')
        },  {
            name: 'product',
            path: 'products/:type',
            component: () => import('./views/products/page.vue'),
            props: true,
        }, {
            path: 'orders',
            component: () => import('./views/Orders')
        }, {
            name: 'customer',
            path: 'customers/:id',
            component: () => import('./views/Customer'),
            props: true,
        }, {
            path: 'cart',
            component: () => import('./views/Cart')
        }, {
            path: 'checkout',
            component: () => import('./views/Checkout')
        },  {
            path: 'login',
            component: () => import('./views/Authentication')
        }, ]
    }]
})
